import { render, staticRenderFns } from "./ChangePasswordNoticeCard.vue?vue&type=template&id=3c4dc985"
import script from "./ChangePasswordNoticeCard.vue?vue&type=script&lang=js"
export * from "./ChangePasswordNoticeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports